import { render, staticRenderFns } from "./SeletorFracassadoItem.vue?vue&type=template&id=bf0965fa"
import script from "./SeletorFracassadoItem.vue?vue&type=script&lang=ts"
export * from "./SeletorFracassadoItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports